import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import PageHeader from "../components/PageHeader";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import InputField from "../../../FinalForm/InputField";
import SelectField from "../../../FinalForm/SelectField";
import SwitchField from "../../../FinalForm/SwitchField";
import ApiZoneSelectField from "../../../FinalForm/api/ApiZoneSelectField";
import {Form} from "react-final-form";
import {apiGetTariff, apiPostTariff} from "./Actions";
import {FiSave} from "react-icons/fi";
import {FilterButton} from "../components/Button";
import {FormCard} from "../components/FormCard";

const TariffForm = () => {
    let [loading, setLoading] = useState(false);
    let [saving, setSaving] = useState(false);
    let [data, setData] = useState(null);
    let user = useSelector((state) => state.user);

    const {id} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        if (id) {
            setLoading(true);
            apiGetTariff(user.activeAreal.id, id, (data) => {
                setData(data);
                setLoading(false);
            }, (err) => {
                setLoading(false);
                handleError(err);
                navigate("/tariff");
            });
        }
    };

    const handleError = (err) => {
        let error = "Nepodařilo se načíst data o tarifu.\n";
        switch (err.data) {
            case "TARIFF_NOT_FOUND": error += "Tarif nebyl nalezen."; break;
            case "UNKNOWN_ERROR":
            default: error += "Neznámá chyba.";
        }
        Toast.error(error);
    };

    const onSubmit = (values) => {
        setSaving(true);
        // zoneIds vždy jako pole (i prázdné) — formulář je autorita nad přiřazením zón.
        // Bez toho by vyprázdněný multiselect poslal null/undefined a odebrání poslední zóny by se neuložilo.
        let newValues = {...values, zoneIds: Array.isArray(values.zoneIds) ? values.zoneIds : []};
        if (id) newValues = {...newValues, tariffId: id};
        apiPostTariff(user.activeAreal.id, newValues, (data) => {
            setData(data);
            setSaving(false);
            navigate("/tariff/detail/" + data.id);
            Toast.success("Úspěšně uloženo.");
        }, (err) => {
            setSaving(false);
            handleError(err);
        });
    };

    return (
        <>
            <PageHeader crumbs={[{label:"Tarify", to:"/tariff"}, {label: id ? "Upravit tarif" : "Vytvořit tarif"}]}/>

            {loading ? <DefaultLoader text={"Načítám data tarifu..."}/> : (
                <Form onSubmit={onSubmit} initialValues={data}
                    render={({handleSubmit}) => (
                        <>
                            <FormCard>
                                <InputField label={"Název (25)"} name={"name"} isMandatory={true} inputType={"text"}/>
                                <SwitchField name={"reverse"} label={"Musí nejdříve vstoupit"}       isMandatory={true} trueValue={0} falseValue={1}/>
                                <SwitchField name={"daily"}   label={"Prochází denně (permanentka)"} isMandatory={true} trueValue={1} falseValue={0}/>
                                <ApiZoneSelectField isMulti={true} name={"zoneIds"} label={"Zóny (kde tarif platí)"}/>
                            </FormCard>
                            {user?.user?.rights?.enigooTurniketsEdit && (
                                <FilterButton type="button" onClick={handleSubmit} loading={saving} text="Uložit" icon={<FiSave size={12}/>} fullWidth/>
                            )}
                        </>
                    )}
                />
            )}
        </>
    );
};
export default TariffForm;
